var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { "justify-space-around": "", wrap: "" } },
    [
      _c("v-flex", { attrs: { xs12: "" } }, [
        _c("div", {
          staticClass: "elevation-5",
          attrs: { id: "mapContainer" },
        }),
      ]),
      _vm._v(" "),
      _vm.mapLoaded ? _c("v-flex", { attrs: { xs10: "" } }) : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }